export const isModalVisibleSelector = (state, modalId) =>
    state.modals === modalId;
